<div class="notification-card" [style.--tint-color]="tintColor">
  <svg-icon
    class="notification-card__close"
    src="assets/icons/icon-close.svg"
    (click)="dismissed.emit()"
    [svgStyle]="{ 'width.rem': 0.75, 'height.rem': 0.75 }"
  ></svg-icon>

  <img
    *ngIf="!illustrationTintVar && !hideIllustration"
    class="notification-card__illustration"
    [src]="illustrationSrc"
    [alt]="illustrationAlt"
  />

  <div
    *ngIf="illustrationTintVar && !hideIllustration"
    class="notification-card__illustration notification-card__illustration--tinted"
    [style.background-color]="'var(' + illustrationTintVar + ')'"
    [style.-webkit-mask-image]="'url(' + illustrationSrc + ')'"
    [style.mask-image]="'url(' + illustrationSrc + ')'"
    role="img"
    [attr.aria-label]="illustrationAlt"
  ></div>

  <div class="notification-card__body">
    <p class="notification-card__title">{{ title }}</p>
    <p *ngIf="!hideCopy" class="notification-card__copy">{{ body }}</p>

    <app-pill-button
      class="notification-card__cta"
      [title]="ctaLabel"
      size="compact"
      [gradientFrom]="ctaGradientFrom"
      [gradientTo]="ctaGradientTo"
      [textColor]="ctaTextColor"
      [showForwardIcon]="true"
      [forwardIconColor]="ctaTextColor"
      (clicked)="ctaClicked.emit()"
    ></app-pill-button>
  </div>
</div>
